import { ArchitectureTypeSeries } from "@sa-nu/core-system/src/graphql/__generated__/types";
import { useCallback, useState } from "react";

import type { HouseRulesMessages } from "./reservation-house-rules";
import ReservationHouseRules from "./reservation-house-rules";

export function useHouseRules(
  areaSlug: string,
  series: ArchitectureTypeSeries,
  messages?: HouseRulesMessages,
) {
  const [agreed, setAgreed] = useState(false);
  const renderHouseRules = useCallback(() => {
    const isSiteOriginalIchinomiya =
      areaSlug === "ichinomiya" && series === ArchitectureTypeSeries.Original;
    return (
      <ReservationHouseRules
        onAgreementChange={setAgreed}
        agreed={agreed}
        isSiteOriginalIchinomiya={isSiteOriginalIchinomiya}
        messages={messages}
      />
    );
  }, [agreed, areaSlug, series, messages]);
  return { renderHouseRules, agreed };
}
